import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import Button from "../../components/CustomButtons/Button.jsx";
import Reply from "@material-ui/icons/Reply";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import headerLinksStyle from "../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

import "react-daterange-picker/dist/css/react-calendar.css";
import { hist } from '../../index';
import clsx from 'clsx';

class HeaderLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPromoCodeFilter: 5,
    };
  }

  handlePromoCodeFilter = (event) => {
    this.setState({
      selectedPromoCodeFilter: event.target.value
    })
  }

  backToPartnersList = () => {
    hist.push('/admin/manageRestaurant')
  }



  render() {
    const { classes } = this.props;
    const {
      selectedPromoCodeFilter,
    } = this.state;
    return (
      <div className="header_main_links manage-offers-header">

        <FormControl className={clsx(classes.formControl, 'filter-by-offer-code')}>
          <InputLabel htmlFor="age-simple">Filter by Ratings</InputLabel>
          <Select
            value={selectedPromoCodeFilter}
            onChange={this.handlePromoCodeFilter}
            inputProps={{
              name: 'percentage',
              id: 'age-simple',
            }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={1}>1</MenuItem>
          </Select>
        </FormControl>
        <div className="new_Card">
          <Button color="info" round className={classes.marginRight} onClick={this.backToPartnersList}>
            <Reply className={classes.icons} /> Back
          </Button>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

export default connect(null)(withStyles(headerLinksStyle)(HeaderLinks));
